var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    transform: "translate(-0.281)",
    fill: "rgba(255,255,255,0)",
    stroke: "#ff0007",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-bin",
    "data-name": "Icon metro-bin",
    d: "M6.834,13.6v23.35a2.342,2.342,0,0,0,2.335,2.335H30.183a2.342,2.342,0,0,0,2.335-2.335V13.6H6.834Zm7,21.015H11.5V18.273h2.335Zm4.67,0H16.174V18.273h2.335Zm4.67,0H20.844V18.273h2.335Zm4.67,0H25.513V18.273h2.335ZM33.1,6.6H25.513V3.679a1.756,1.756,0,0,0-1.751-1.751H15.59a1.756,1.756,0,0,0-1.751,1.751V6.6H6.25A1.756,1.756,0,0,0,4.5,8.349v2.919H34.853V8.349A1.756,1.756,0,0,0,33.1,6.6Zm-9.924,0h-7V4.292h7V6.6Z",
    transform: "translate(17.501 17.072)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.ceb626d259b59022183c4d31d0d9af54.svg";
export { ForwardRef as ReactComponent };